import { render, staticRenderFns } from "./ls-form.vue?vue&type=template&id=40e886b2&scoped=true"
import script from "./ls-form.vue?vue&type=script&lang=ts"
export * from "./ls-form.vue?vue&type=script&lang=ts"
import style0 from "./ls-form.vue?vue&type=style&index=0&id=40e886b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e886b2",
  null
  
)

export default component.exports